import React, {useEffect, useRef} from 'react';
import { useLocation, useNavigate } from 'react-router';
import {
  Button,
  Card,
  FlexItem, FlexLayout, H2, Spinner, StackLayout, Text
} from '@salt-ds/core';
import CardHeader from '../../components/common/card-header/CardHeader';
import StepTracker from '../../components/common/StepTracker';
import RegisterComputerRegistrationOptionsForm from './RegisterComputerRegistrationOptionsForm';
import Constants from '../../components/common/Constants';
import CardAlert from "../../components/common/card-alert/CardAlert";
import {customerServiceLink} from '../../common/ApiUtils';
import {useIntl} from 'react-intl';

function RegisterComputerRegistrationOptions() {

  const location = useLocation();
  const navigate = useNavigate();
  const[isLoading, setIsLoading] = React.useState(false);
  const [hasError, setHasError] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const mainRef = useRef(null);

  const showErrorOnPage = (msg) => {
    setErrorMessage(msg);
    setHasError(true);
    setIsLoading(false);
  };

  const intl = useIntl();
  useEffect(() => {
    document.title = intl.formatMessage({id: 'logon.ui.registercomputer.step2.page.title'});
    // Set focus to main element for screen reader announcement
    if (mainRef.current) {
      mainRef.current.focus();
    }

    if (location.state?.from !== Constants.registerComputer) {
      navigate('/');
    }
  }, [location, navigate]);

  return (
    <main ref={mainRef} role="main" aria-label="Register Computer Registration Options" tabIndex="-1">
      <FlexLayout className={"page-content"}>
        {isLoading ? (
          <FlexItem className="spinner-wrapper">
            <Spinner data-testid="spinner-loading" aria-label="loading" role="status" size="medium" style={{marginLeft: "50%"}} />
          </FlexItem>
        ) : (
            <FlexItem className={`error-wrapper ${hasError ? 'visible' : ''}`}>
            <div>
              <CardAlert status="error" setHasError={setHasError}>{errorMessage}</CardAlert>
            </div>
          </FlexItem>
        )}
        <FlexItem>
          <Card className="card-wrapper">
            <FlexItem className="card-content">
              <StackLayout gap={5} wrap={true}>
                <CardHeader heading={Constants.registerComputerTitle} subheading={Constants.registerComputerStep2Title} style={{maxWidth: "20rem"}}/>
                <StepTracker label1={intl.formatMessage({id: 'logon.ui.registercomputer.flow.step1'})} step1="completed"
                  label2={intl.formatMessage({id: 'logon.ui.registercomputer.flow.step2'})} step2="active"
                  label3={intl.formatMessage({id: 'logon.ui.registercomputer.flow.step3'})} step3="pending" />
                <FlexItem>
                  <Text >
                    {Constants.registerComputerStep2InstructionHeader(customerServiceLink)}
                  </Text>
                </FlexItem>
                <FlexItem>
                  <H2>{Constants.registrationOptions}</H2>
                  <Text style={{paddingTop:"1rem"}}>Please Choose one (required).</Text>
                </FlexItem>
                <RegisterComputerRegistrationOptionsForm
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  showErrorOnPage={showErrorOnPage}
                  setHasError={setHasError}
                />
              </StackLayout>
            </FlexItem>
          </Card>
        </FlexItem>
      </FlexLayout>
    </main>
  );
}

export default RegisterComputerRegistrationOptions;